
var isValidBoundedCoordinates = function (boundedCoordParamString) {
    if (boundedCoordParamString) {
        var envelope = boundedCoordParamString.match(/ENVELOPE\((.*?)\)/);
        if (Array.isArray(envelope) && envelope.length === 2 && boundedCoordParamString && boundedCoordParamString.length > 0) {
            return true;
        }
    }
    return false;
};